// Dependencies
import React from "react";
import { createPortal } from "react-dom";

import useToastStore from "./Store";
// Components
import { Toast } from "./Toast";

// Styles
import css from "./Toast.module.scss";

export * from "./Toast";

/**
 * @deprecated Use the Toast component from the py-components package instead
 */
export const ToastContainer = () => {
	const [hasHover, setHasHover] = React.useState(false);
	const [toasts, removeToast] = useToastStore((state) => [state.toasts, state.removeToast]);

	return createPortal(
		<div className={css.container} onMouseEnter={() => setHasHover(true)} onMouseLeave={() => setHasHover(false)}>
			<div>
				{toasts.map((toast, index) => {
					return (
						<Toast
							{...toast}
							key={toast.id}
							hasHover={hasHover}
							onClose={() => removeToast(toast.id)}
							onFinish={() => removeToast(toast.id)}
							positionIndex={toasts.length - 1 - index}
						/>
					);
				})}
			</div>
		</div>,
		document.body
	);
};
